(function () {
  var STORAGE_KEY = 'affiliate_code';
  var COOKIE_DAYS = 90;

  var DYNAMIC_CHECKOUT_SELECTOR =
    'shop-pay-button,' +
    '[data-shopify="payment-button"],' +
    '[data-shopify="dynamic-checkout-cart"],' +
    '.shopify-payment-button button,' +
    '.shopify-payment-button__button,' +
    '.additional-checkout-buttons button,' +
    '.shopify-cleanslate button';

  function setCookie(name, value, days) {
    try {
      var expires = new Date(Date.now() + days * 864e5).toUTCString();
      document.cookie =
        name +
        '=' +
        encodeURIComponent(value) +
        '; expires=' +
        expires +
        '; path=/; SameSite=Lax';
    } catch (e) {}
  }

  function getCookie(name) {
    try {
      var pattern = new RegExp(
        '(?:^|; )' + name.replace(/([.$?*|{}()\[\]\\\/+^])/g, '\\$1') + '=([^;]*)'
      );
      var match = document.cookie.match(pattern);
      return match ? decodeURIComponent(match[1]) : null;
    } catch (e) {
      return null;
    }
  }

  function readLocal(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function writeLocal(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (e) {}
  }

  function getStoredCode() {
    return readLocal(STORAGE_KEY) || getCookie(STORAGE_KEY);
  }

  function captureFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      var aft = params.get('aft');
      if (!aft) return;

      writeLocal(STORAGE_KEY, aft);
      setCookie(STORAGE_KEY, aft, COOKIE_DAYS);
    } catch (e) {}
  }

  function syncCart() {
    var code = getStoredCode();
    if (!code) return;

    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ attributes: { affiliate_code: code } }),
    }).catch(function () {});
  }

  function ensureHiddenInput(form, name, value) {
    var existing = form.querySelector('input[name="' + name + '"]');
    if (existing) {
      existing.value = value;
    } else {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    }
  }

  function injectIntoProductForms() {
    var code = getStoredCode();
    if (!code) return;

    var forms = document.querySelectorAll(
      'form[action*="/cart/add"], form[data-type="add-to-cart-form"]'
    );
    for (var i = 0; i < forms.length; i++) {
      ensureHiddenInput(forms[i], 'properties[_affiliate_code]', code);
    }
  }

  function watchForNewForms() {
    if (typeof MutationObserver !== 'function') return;
    var obs = new MutationObserver(function () {
      injectIntoProductForms();
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  // === Buy It Now bypass ===
  // Shopify's dynamic checkout buttons (Shop Pay / Buy It Now / wallets)
  // create their own checkout session that does NOT reliably read cart
  // attributes set asynchronously. So when a user clicks one with an
  // affiliate code present, we:
  //   1. Cancel the widget's click
  //   2. POST /cart/add.js ourselves (adds product + line-item property)
  //   3. POST /cart/update.js (sets cart-level attribute)
  //   4. Redirect to /checkout, which uses the prepared cart
  // End result: same one-click UX but the affiliate code is guaranteed
  // present on the order.

  function getFormForButton(btn) {
    // Buttons are usually inside the product form.
    var form = btn.closest && btn.closest('form');
    if (form) return form;
    // Fallback: associate by aria-controls or by the first add-to-cart form.
    return document.querySelector('form[action*="/cart/add"]');
  }

  function buyNowBypass(e) {
    var code = getStoredCode();
    if (!code) return; // No code → don't interfere

    var target =
      e.target && e.target.closest
        ? e.target.closest(DYNAMIC_CHECKOUT_SELECTOR)
        : null;
    if (!target) return;

    var form = getFormForButton(target);
    if (!form) return;

    var variantInput = form.querySelector('input[name="id"]');
    if (!variantInput || !variantInput.value) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var variantId = variantInput.value;
    var qtyInput = form.querySelector('input[name="quantity"], select[name="quantity"]');
    var quantity = qtyInput && qtyInput.value ? parseInt(qtyInput.value, 10) : 1;
    if (!quantity || isNaN(quantity)) quantity = 1;

    // Collect any properties already on the form (e.g. gift card recipient).
    var properties = { _affiliate_code: code };
    var propertyInputs = form.querySelectorAll('input[name^="properties["]');
    for (var i = 0; i < propertyInputs.length; i++) {
      var input = propertyInputs[i];
      var match = input.name.match(/properties\[([^\]]+)\]/);
      if (match && input.value) {
        properties[match[1]] = input.value;
      }
    }

    var addPayload = {
      id: variantId,
      quantity: quantity,
      properties: properties,
    };

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(addPayload),
    })
      .then(function () {
        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ attributes: { affiliate_code: code } }),
        });
      })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function () {
        // If anything failed, fall back to the cart page so the user
        // doesn't get stuck. They can manually proceed to checkout.
        window.location.href = '/cart';
      });
  }

  function installDynamicCheckoutGuard() {
    document.addEventListener('click', buyNowBypass, true);
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  captureFromUrl();
  syncCart();

  onReady(function () {
    injectIntoProductForms();
    watchForNewForms();
    installDynamicCheckoutGuard();
  });

  window.addEventListener('pageshow', function () {
    injectIntoProductForms();
    syncCart();
  });
})();
